import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FINCEN_ENTRY_BASE_PATH } from '../../../../../../../../../features/watchlist/fincen/entry/fincen-entry-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/entry/_entry')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'fincen-entry-list',
        label: 'FinCEN',
        to: FINCEN_ENTRY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
